import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import TurnTab from './TurnTab';
import PF2MTabs from '~/components/PF2MTabs';

const UndergroundTurn = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Shift') },
  ];
  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<TurnTab />) : null}
    </>
  );
};

export default withStyles(styles)(UndergroundTurn);
